import { StyleSheet } from '@react-pdf/renderer';

const palette = {
  bg: '#FFFFFF',
  text: '#111827',
  muted: '#6B7280',
  border: '#E5E7EB',
  headerBg: '#0C1117',
  headerText: '#FFFFFF',
  primary: '#0EA5E9',
};

export default StyleSheet.create({
  page: {
    padding: 24,
    backgroundColor: palette.bg,
    color: palette.text,
    fontSize: 10,
  },

  // Brand header (logo + name)
  brandHeader: {
    flexDirection: 'row',
    //alignItems: 'center',
    flexWrap: 'nowrap',
    // backgroundColor: palette.headerBg,
    // paddingVertical: 6,
    // paddingHorizontal: 16,
    // borderRadius: 8,
    marginBottom: 14,
  },
  brandLogo: { width: 'auto', height: 40, marginRight: 10 },

  brandWordmark: {
    fontSize: 20,
    fontWeight: 700,
    color: palette.headerText,
  },
  brandSuperscript: {
    fontSize: 10,
    marginLeft: 4,
    marginTop: -10,
  },

  // Title block
  header: { marginBottom: 8 },
  h1: { fontSize: 14, fontWeight: 700, marginBottom: 2 },
  h2: { fontSize: 12, color: '#374151' },

  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  muted: { color: palette.muted },

  sectionTitle: {
    marginTop: 14,
    marginBottom: 6,
    fontSize: 12,
    fontWeight: 700,
  },

  // Chips grid
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 10,
  },
  chip: {
    width: '48%',
    borderWidth: 1,
    borderColor: palette.border,
    borderRadius: 6,
    padding: 8,
    marginRight: 8,
    marginBottom: 8,
  },
  chipTitle: { fontSize: 9, color: palette.muted, marginBottom: 2 },

  // Table
  table: {
    borderWidth: 1,
    borderColor: palette.border,
    borderRadius: 6,
    overflow: 'hidden',
  },
  trHead: {
    flexDirection: 'row',
    backgroundColor: palette.primary,
    color: '#FFFFFF',
    paddingVertical: 6,
    paddingHorizontal: 6,
    fontWeight: 700,
  },
  tr: {
    flexDirection: 'row',
    paddingVertical: 6,
    paddingHorizontal: 6,
    borderTopWidth: 1,
    borderTopColor: palette.border,
  },
  cell: { fontSize: 10, paddingRight: 6 },

  // column widths
  cDay: { width: '10%' },
  cDate: { width: '16%' },
  cAM: { width: '24%' },
  cPM: { width: '24%' },
  cDinner: { width: '12%' },
  cHotel: { width: '14%' },

  // Footer page numbers
  footer: {
    position: 'absolute',
    bottom: 16,
    left: 24,
    right: 24,
    textAlign: 'center',
    color: palette.muted,
    fontSize: 10,
  },
});
